import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class ReportCenterService {

  constructor(private httpClientService: HttpClientService) { }

  public getReportList(){
    return this.httpClientService.get(`${CONFIG.REPORTCENTER.GET_REPORTLIST}`);
  }


  public createReport(data:any) {
    return this.httpClientService.post(CONFIG.REPORTCENTER.CREATE_REPORT, data);
  }
  public autoSearchReport(seachkey:string){
    return this.httpClientService.get(`${CONFIG.REPORTCENTER.AUTOSEARCHREPORT}?searchText=${seachkey}`);
  }
  public getReportName(formCode: string) {
  return this.httpClientService.get(`${CONFIG.REPORTCENTER.GETREPORTBYNAME}?formCode=${formCode}`);
}
  public getReport(data: any, GroupName: string) {
    return this.httpClientService.get(`${CONFIG.REPORTCENTER.GETREPORT}?GroupName=${GroupName}`, data)
  }
  public getGroupNames() {
    return this.httpClientService.get(`${CONFIG.REPORTCENTER.GETREPORTGROUP}`)
  }
}
